/**
 * the CommentsService class handles comment API-requests
 */

import { Injectable } from '@angular/core';
import { Http, Headers, Request, RequestOptions, RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { api } from './api';
import { UserAuthService } from './user-auth.service';

@Injectable()
export class CommentsService {

	private commentsUrl: string = api.base + '/comments';
	private typesUrl: string = api.base + '/comments-types';

	constructor(
		private http: Http,
		private userAuthService: UserAuthService
	) { }

	private getRequestOptions( options ) {
		let headers = new Headers();
		headers.append( 'Accept', 'application/json' );
		headers.append( 'Authorization', 'Bearer ' + this.userAuthService.getToken() );
		options.headers = headers;
		let requestOptions = new RequestOptions(options);
		return requestOptions;
	}

	private handleError(error: Response | any) {
		return Observable.throw(error);
	}

	createComment(modelID: string, modelEntityID: number, comment: string, type: number): Observable<{}> {

		let body = {
			model_id: modelID,
			model_entity_id: modelEntityID,
			comment: comment,
			type: type,
		}

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Post,
			url: this.commentsUrl,
			body: body,
		}

		let comment$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return comment$;
	}

	deleteComment(commentID: number): Observable<{}> {

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Delete,
			url: this.commentsUrl + '/' + commentID,
		}

		let comment$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return comment$;
	}

	getType(id: number) {

		let requestOptions = {
			withCredentials: true,
			method: RequestMethod.Get,
			url: this.typesUrl + '/' + id,
		}

		let type$ = this.http
						.request( new Request(this.getRequestOptions(requestOptions)) )
						// .do( (res: Response) => console.log( res ) )
						.map( (res: Response) => res.json() )
						// .do( (res: Response) => console.log( res ) )
						.catch( this.handleError );

		return type$;

	}

}



// WEBPACK FOOTER //
// ./src/app/comments.service.ts